.form {
	@apply yst-space-y-4 yst-mt-6;
}

.orSeparator {
	@apply
	yst-block
	yst-mx-auto
	yst-py-1
	yst-w-36
	yst-text-center
	yst-border-y;
}
